import { Observable } from 'rxjs';

export class DialogStateModel {
  title: string;
  body: string;
  type: string;
  confirmText: string;
  critical: boolean;
  onConfirm: () => Observable<void>;
  onCancel: () => Observable<void>;
}
